import Vue from 'vue'
import Router from 'vue-router'
import Routes from '@/data/routes.json'
// import scrollBehavior from './scroll-behavior'
import store from '../store'
import services from '../services'

var routersNames = []

Vue.use(Router)

export function createRouter () {
  function route (path, component, redirect, meta, children) {
    const hasChildren = Array.isArray(children)
    return {
      path: path,
      name: createRouterName(component, path),
      component: () => import(`@/pages/${component}.vue`),
      redirect: redirect,
      meta: meta,
      children: hasChildren
        ? children.map(r => route(
          r.route,
          r.component,
          r.redirect,
          r.meta,
          r.children
        )) : []
    }
  }

  function createRouterName (component, path) {
    let routerName = component.split('/')[component.split('/').length - 1]
    if (routersNames.includes(routerName)) {
      routerName += path.split('/')[path.split('/').length - 1]
    } else {
      routersNames.push(routerName)
    }
    return routerName
  }

  const routes = Routes.map(r => route(
    r.route,
    r.component,
    r.redirect,
    r.meta,
    r.children
  ))

  routes.push({
    path: '*',
    redirect: to => {
      let path = to.path !== '/' ? to.path : '/login'
      console.log(to)
      if (!to.name) {
        let url = store.state.auth.token !== null
          ? store.state.auth.role !== 'guest' ? `/dashboard` : '/login' : `/login`
        return url
      }
      return `/${path}`
    }
  })

  const router = new Router({
    mode: 'history',
    routes: routes
  })

  router.beforeEach((to, from, next) => {
    let ensuing = function () {
      let allowed = services.checkingRoles(store.state.auth.role, permissions)
      if (allowed.admitted) {
        next()
      } else {
        next(allowed.redirect)
      }
    }

    // back button
    if (to.meta.hasOwnProperty('back') && to.meta.back) {
      store.commit('SET_BACK', true)
    } else {
      store.commit('SET_BACK', false)
    }

    // auth
    let permissions = []
    for (let i = to.matched.length; i > 0; i--) {
      if (to.matched[i - 1].meta.roles) {
        permissions = to.matched[i - 1].meta.roles
        break
      }
    }

    if (!store.getters.init) {
      store.dispatch('INIT_APP', to).then(() => {
        ensuing()
      })
    } else {
      ensuing()
    }
  })

  return router
}



// WEBPACK FOOTER //
// ./src/router/index.js